import { TimeMachineIcon, ArrowDownIcon } from '@/components/icons/svg-icons'
import { Button } from '@nf/ui'
import { cx } from 'class-variance-authority'
import { motion } from 'framer-motion'
import { matchStyles } from '../match/match.style'
import { SportMatchModel, StrongTeam } from '@nf/types/odds'
import { matchService } from '@/services/match.service';
import { useLiveTimer } from '@/features/odds-page/hooks/use-live-timer'
import { MatchTimer } from '@/features/sportsbook-aside/components/match-item/match-timer'

interface CollapseMatchInfoProps {
    match: SportMatchModel;
    isOpen: boolean;
    toggleMatch(): void;
    canSeeTimeMachine?: boolean;
    toggleTimeMachine?(): void;
    homeTeamName: string;
    awayTeamName: string;
    
}
export const CollapseMatchInfo = ({
	match,
	toggleMatch,
	isOpen,
	canSeeTimeMachine,
	toggleTimeMachine,
	homeTeamName,
	awayTeamName
}: CollapseMatchInfoProps) => {
	const liveTimer = useLiveTimer(match);
	const strongTeam = matchService.getStrongTeam(match.BetTypes);

	return (
		<motion.div
			className={matchStyles.matchHeader}
			initial="closed"
			animate={isOpen ? 'closed' : 'open'}
			variants={{
				open: { height: '45px', opacity: 1 },
				closed: { height: 0, opacity: 0 }
			}}
			onClick={toggleMatch}
		>
			<div className={matchStyles.statsMini}>
				{
					match.IsLive ? 
						<div className={matchStyles.score}>{`${match.T1V} - ${match.T2V}`}</div> : null
				}
				{
					match.IsLive ?
						<div className="match-timer">
							<MatchTimer match={match} />
						</div> :
						<div className="match-timer"><div className="match-time" dangerouslySetInnerHTML={{ __html: liveTimer.matchBeginTime }} /></div>
				}
			</div>
			<div className={matchStyles.teamsMini}>
				<div className={matchStyles.teamMini}>
					<div className={cx(matchStyles.teamNameMini, 'multi-line-ellipsis', strongTeam === StrongTeam.Home && matchStyles.teamStrong)}>{homeTeamName}</div>
					{
						match.Rc1 ? 
							<div className={cx('red-card', matchStyles.redcard)}>{match.Rc1}</div>: null
					}
				</div>
				<div className={matchStyles.teamMini}>
					<div className={cx(matchStyles.teamNameMini, 'multi-line-ellipsis', strongTeam === StrongTeam.Away && matchStyles.teamStrong)}>{awayTeamName}</div>
					{
						match.Rc2 ?
							<div className={cx('red-card', matchStyles.redcard)}>{match.Rc2}</div> : null
					}
				</div>
			</div>
			{
				canSeeTimeMachine && toggleTimeMachine ? (
					<Button
						variant="icon"
						className={matchStyles.timeMachineButton}
						onClick={toggleTimeMachine}
					>
						<TimeMachineIcon />
					</Button>
				) : null
			}
			<Button
				variant="icon"
				className={matchStyles.arrowButton}
			>
				<ArrowDownIcon />
			</Button>
		</motion.div>
	)
}